import Lottie from 'lottie-react';
import { HeadTitle, Explain, ExplainItem, Popup } from 'oui';
import useLoading from '../../application/bloc/useLoading';
import { SideBox } from '../etc/LBox/LBox';
import loading from '../../assets/lottie/loading.json';

const Loading = () => {
  const { titleContent, popup, NOTI_PRE_REG } = useLoading();

  return (
    <>
      <HeadTitle
        textTitle={titleContent.title}
        subTitle={titleContent.subTitle}
      />

      <Lottie animationData={loading} />

      {/*<SideBox>*/}
      {/*  <Explain*/}
      {/*    title={'정기 알림 서비스란?'}*/}
      {/*    children={NOTI_PRE_REG.map((item) => {*/}
      {/*      return (*/}
      {/*        <ExplainItem*/}
      {/*          title={item.title}*/}
      {/*          subTitle={item.subTitle}*/}
      {/*          avatar={{ source: item.source, alt: item.alt }}*/}
      {/*        />*/}
      {/*      );*/}
      {/*    })}*/}
      {/*  />*/}
      {/*</SideBox>*/}

      <Popup
        title={popup.message}
        description={popup.description}
        isPopupOpen={popup.open}
        confirmBtn={{ text: popup.confirmText, onClick: popup.onClickConfirm }}
        cancelBtn={{ text: popup.cancelText, onClick: popup.onClickCancel }}
      />
    </>
  );
};

export default Loading;
